import styled from 'styled-components';

const ShareStyle = styled.div`
	--distanceShare: var(--sp3x);
	--distanceShareInline: var(--sp2x);
	--iconWH: var(--sp7x);

	--socialsIconSize: 18px;

	display: flex;
	flex-direction: ${({ $inline }) => ($inline ? 'row' : 'column')};
	align-items: end;
	gap: ${({ $inline }) => ($inline ? 'var(--distanceShareInline)' : 'var(--distanceShare)')};

	.link-item {
		min-width: var(--iconWH);
		max-width: var(--iconWH);
		height: var(--iconWH);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background-color: var(--black1000);
		color: var(--white1000);

		i {
			font-size: calc(var(--socialsIconSize) * 2);
			transition: all var(--trTime) ease-out;
		}
	}

	.media-share {
		cursor: pointer;
	}

	.link-copy-icon {
		position: relative;
		overflow: visible;
	}

	.clipboard-text-message {
		background-color: var(--white1000);
		position: absolute;
		bottom: 0;
		right: 0;
		width: fit-content;
		height: fit-content;
		transform: translateY(100%);
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.link-item {
				&:hover {
					i {
						transform: scale(1.2);
					}
				}
			}
		}
	}

	//! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--iconWH: var(--sp6x);
		--socialsIconSize: var(--sp2x);
	}

	//! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--iconWH: var(--sp6x);
	}

	//! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--iconWH: var(--sp5x);
		--socialsIconSize: 14px;
	}

	//! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--iconWH: var(--sp5x);
		--distanceShare: var(--sp2x);
	}

	//! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--iconWH: var(--sp4x);
		--distanceShare: var(--sp1-5x);
		--distanceShareInline: var(--sp1x);

		--socialsIconSize: 10px;
	}

	//! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--distanceShare: var(--sp1-5x);
		--distanceShareInline: var(--sp1x);
		--iconWH: var(--sp4x);

		flex-direction: row;
		margin-top: ${({ $inline }) => ($inline ? 'unset' : 'var(--sp4x)')};
	}

	//! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceShare: var(--sp1-5x);
		--iconWH: var(--sp4x);

		justify-content: ${({ $inline }) => ($inline ? 'space-between' : 'unset')};
	}
`;

export default ShareStyle;
